module.exports = __webpack_public_path__ + "media/PAG91-03.3d4eeeca.mp3";